import RootStyles from './SEOPlanningWizard.module.scss'
import Styles from './SiteResult.module.scss'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'

const LoadingSite = () => {
  return (
    <div className={Styles.resultContainer}>
      <Checkbox size="lg" isDisabled={true} />
      <div className={Styles.resultCard}>
        <div className={Styles.header}>
          <LineSkeleton className={Styles.faviconShimmer} />
          <div className={Styles.pageInfoStub}>
            <LineSkeleton className={Styles.pageInfoShimmer} />
            <LineSkeleton className={Styles.pageInfoShimmer} />
          </div>
        </div>
        <div className={Styles.snippet}>
          <LineSkeleton className={Styles.stubShimmer} />
        </div>
      </div>
    </div>
  )
}

export const SitesLoadingState = () => {
  return (
    <div className={RootStyles.siteResults}>
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <LoadingSite key={index} />
        ))}
    </div>
  )
}
